import React, { useState, useEffect } from "react";

import axios from "axios";
import Avatar from "@mui/material/Avatar";
import GroupIcon from "@mui/icons-material/Group";

// My Files
import { encodeImage } from "../../utility";

export default function ConversationGroupAvatar(props) {
    const [avatar, setAvatar] = useState();
    const [foundImage, setFoundImage] = useState(false);

    useEffect(() => {
        const getImage = () => {
            if (!props.conversation) {
                return;
            }

            if (props.conversation.avatar) {
                setAvatar(props.conversation.avatar);
                setFoundImage(true);
                return;
            }

            if (!props.conversation.imageURL) {
                return;
            }

            console.log("Downloading Group Avatar from Firebase");

            axios
                .get(props.conversation.imageURL, {
                    responseType: "arraybuffer",
                })
                .then((response) => {
                    const buffer = Buffer.from(response.data, "base64");
                    const photo =
                        "data:image/png;base64," + encodeImage(buffer);

                    setAvatar(photo);
                    props.conversation.avatar = photo;
                    setFoundImage(true);
                })
                .catch((ex) => {
                    console.error(ex);
                });
        };

        getImage();
    }, [props.conversation, avatar]);

    // if (!avatar) {
    //     return <Skeleton variant="circle" width={40} height={40} />;
    // }

    return (
        <div>
            {foundImage ? (
                <Avatar
                    alt="Profile Picture"
                    src={avatar}
                    variant={props.variant}
                />
            ) : (
                <Avatar
                    alt="Profile Picture"
                    variant={props.variant}
                    sx={{
                        color: "primary.main",
                        backgroundColor: "rgba(0, 149, 61, 0.1)",
                    }}
                >
                    <GroupIcon />
                </Avatar>
            )}
        </div>
    );
}
